// FileUpload.jsx
import { useState } from "react";
import styles from "./InputFile.module.scss";
import { useDispatch } from "react-redux";
import { setActiveAssistant } from "../../store/slices/assistantSlice";
import AddFilesIcon from "../../assets/icons/AddFilesIcon";
import { errorToast } from "../../utils/methods/toast";

export const InputFile = ({ assistant }) => {
  const dispatch = useDispatch();
  const filesList = assistant?.files || [];
  const [dragging, setDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);

    // Обработка загруженных файлов
    if (e.dataTransfer.files.length) {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files.length) {
      handleFiles(e.target.files);
    }
  };

  const validateFile = (file) => {
    const filename = file;
    const matched = filename.match(/pdf|md|txt|csv|html|docx|pptx|ppt/);
    if (matched !== null) return true;
    return false;
  };

  const handleFiles = (files) => {
    if (files && assistant) {
      const newFiles = Array.from(files).filter((file) =>
        validateFile(file.name)
      );

      if (newFiles.length === 0) {
        errorToast("Недопустимый формат файла!");
        return;
      }

      const updatedFiles = [...filesList];

      newFiles.forEach((file) => {
        const duplicate = updatedFiles.some(
          (existingFile) => existingFile.name === file.name
        );

        if (duplicate) {
          errorToast(`Файл "${file.name}" уже был выбран!`);
        } else {
          updatedFiles.push(file);
        }
      });

      dispatch(
        setActiveAssistant({
          ...assistant,
          files: updatedFiles,
        })
      );
    }
  };

  return (
    <div className={styles.uploadContainer}>
      <label
        className={
          dragging
            ? `${styles.addFilesInput} ${styles.dragging}`
            : styles.addFilesInput
        }
        htmlFor="upload_file"
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <div className={styles.fileInfo}>
          <AddFilesIcon size={48} fill={"#6B7280"} />
          <span className={styles.addFilesTitle}>Добавление новых файлов</span>
          <span className={styles.addFilesSubtitle}>
            Нажмите или перетащите файлы сюда
          </span>
        </div>
        <input
          type="file"
          className={styles.inputFile}
          onChange={handleFileChange}
          id="upload_file"
          multiple
          accept=".pdf,.md,.txt,.csv,.html,.docx,.pptx,.ppt"
        />
      </label>
    </div>
  );
};
